import React from 'react';

interface SegmentedControlOption<T extends string> {
  label: string;
  value: T;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
}

interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: Array<SegmentedControlOption<T>>;
  className?: string;
}

export function SegmentedControl<T extends string>({ value, onChange, options, className }: SegmentedControlProps<T>) {
  return (
    <div className={`flex items-center gap-1 bg-gray-100 rounded-lg p-1 ${className || ''}`} role="tablist">
      {options.map((opt) => (
        <button
          key={opt.value}
          role="tab"
          aria-selected={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={`${
            value === opt.value ? 'bg-white text-genie-primary shadow-sm' : 'text-gray-700 hover:text-gray-900'
          } px-3 py-1.5 rounded-md flex items-center gap-2 transition-colors`}
        >
          {opt.icon}
          <span className="text-sm">{opt.label}</span>
          {opt.badge}
        </button>
      ))}
    </div>
  );
}


